// material design iconを使用
import '@mdi/font/css/materialdesignicons.css';

import Vue from 'vue';
import { UserVuetifyPreset } from 'vuetify';
import VuetifyConfirm from 'vuetify-confirm';
import VuetifyToast from 'vuetify-toast-snackbar';
import Vuetify, { VBtn, VIcon, VSnackbar } from 'vuetify/lib';
import ja from 'vuetify/src/locale/ja';

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon,
  },
});
const vuetifyOptions: Partial<UserVuetifyPreset> = {
  lang: {
    locales: { ja },
    current: 'ja',
  },
  icons: {
    // material design iconを使用
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#2B6639',
      },
    },
  },
};

const vuetify = new Vuetify(vuetifyOptions);

Vue.use(VuetifyToast, {
  x: 'center',
  y: 'top',
  icon: 'info',
  classes: ['body-2'],
  shorts: {
    custom: {
      color: 'purple',
    },
  },
  $vuetify: vuetify.framework,
});

Vue.use(VuetifyConfirm, {
  vuetify: vuetify,
  buttonTrueText: 'はい',
  buttonFalseText: 'いいえ',
  persistent: true,
});

export default vuetify;
